import { defineSlotRecipe as e } from "@pandacss/dev";
import { createAnatomy as r } from "../../../node_modules/@ark-ui/anatomy/node_modules/@zag-js/anatomy/dist/index.mjs";
const i = r("sidebar", [
  "root",
  "sidebar",
  "trigger",
  "group",
  "separator",
  "item",
  "itemText",
  "menuItem",
  "asideRoot",
  "asideGroup",
  "asideTrigger",
  "asideContent",
  "asideCloseButton"
]), t = e({
  className: "sidebar",
  slots: i.keys(),
  base: {
    root: {
      position: "relative"
    },
    trigger: {
      position: "absolute",
      top: "50px",
      right: "-30px"
    },
    separator: {
      marginY: "spacing-4",
      height: "1px",
      width: "100%",
      backgroundColor: "border-secondary"
    },
    group: {
      gap: "spacing-0,5"
    },
    item: {
      display: "flex",
      alignItems: "center",
      borderRadius: "radius-3",
      cursor: "pointer",
      transition: "background-color 0.1s linear",
      _hover: {
        backgroundColor: "bg-secondary_hover"
      },
      _selected: {
        backgroundColor: "bg-secondary_hover"
      }
    },
    itemText: {
      size: "md"
    },
    asideGroup: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "spacing-3"
    },
    asideTrigger: {
      width: "100%",
      position: "relative",
      padding: "spacing-4",
      display: "flex",
      alignItems: "center",
      borderRadius: "radius-3",
      cursor: "pointer",
      transition: "background-color 0.1s linear",
      _hover: {
        backgroundColor: "bg-secondary_hover"
      },
      '&[aria-selected="true"]': {
        backgroundColor: "bg-secondary_hover",
        "& > *": {
          "&::after": {
            content: '""',
            position: "absolute",
            right: "calc(-16px + 4px)",
            top: "50%",
            transform: "translateY(-50%)",
            width: "4px",
            height: "90%",
            borderTopLeftRadius: "radius-1",
            borderBottomLeftRadius: "radius-1",
            backgroundColor: "fg-primary"
          }
        }
      }
    }
  },
  variants: {
    side: {
      right: {
        trigger: {
          right: "-30px"
        },
        item: {
          padding: "spacing-4"
        }
      }
    },
    open: {
      none: {
        item: {
          padding: "spacing-4"
        }
      },
      sidebar: {
        item: {
          paddingX: "spacing-3",
          paddingY: "spacing-2,5"
        }
      },
      aside: {
        item: {
          padding: "spacing-4"
        }
      }
    }
  }
});
export {
  t as sidebar
};
